import { defaultColors } from '@assets/colors/defaultColors';
import logger from '@src/utils/logger.ts';

const RECENT_COLORS_KEY = 'recent-colors';
const MAX_RECENT_COLORS = 5;

export function getRecentColors(): string[] {
  try {
    const stored = localStorage.getItem(RECENT_COLORS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    logger.error('Failed to get recent colors from localStorage');
    return [];
  }
}

export function addRecentColor(color: string): void {
  try {
    const normalizedColor = color.toLowerCase();

    // デフォルト色は履歴に追加しない（大文字小文字を正規化して比較）
    if (defaultColors.map((c) => c.toLowerCase()).includes(normalizedColor)) {
      return;
    }

    const recentColors = getRecentColors();
    const filteredColors = recentColors.filter((c) => c.toLowerCase() !== normalizedColor);
    const updatedColors = [normalizedColor, ...filteredColors].slice(0, MAX_RECENT_COLORS);

    localStorage.setItem(RECENT_COLORS_KEY, JSON.stringify(updatedColors));
  } catch {
    logger.error('Failed to add recent color to localStorage');
  }
}
